import { Form, Slider } from 'antd'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'

const StyledSlider = styled(Slider)`
  width: 95% !important;
  padding: 0px !important;
  height: 2px !important;
  margin: 26px 10px !important;

  .ant-slider-handle {
    width: 20px;
    height: 20px;
    margin-top: -9px;

    background: #ffffff;

    border: 1px solid #f2f3f5;
    box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  }
  .ant-slider-track {
    background-color: ${COLORS.PRIMARY} !important;
  }

  .ant-slider-rail,
  .ant-slider-track {
    height: 4px !important;
  }

  .ant-slider-dot {
    border: none !important;
  }

  .ant-slider-mark-text {
    transform: none !important ;
  }
`

const StyledStrong = styled.strong`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
`

const StyledFormItem = styled(Form.Item)`
  width: 100%;
`

const CustomRangeSlider = ({
  minValue,
  setMinValue,
  maxValue,
  setMaxValue,
  min,
  max,
  percent,
  step = 1,
  ...rest
}) => {
  const labels = {
    [min]: {
      label: <StyledStrong>{percent ? `${min}%` : min}</StyledStrong>,
    },
    [max]: {
      style: {
        left: '95%',
      },
      label: <StyledStrong>{max || ``}</StyledStrong>,
    },
  }

  const onChange = value => {
    setMinValue(value[0])
    setMaxValue(value[1])
  }

  return (
    <StyledFormItem>
      <StyledSlider
        range
        step={step}
        defaultValue={[minValue, maxValue]}
        onChange={onChange}
        marks={labels}
        min={min}
        max={max}
        value={[minValue, maxValue]}
        {...rest}
      />
    </StyledFormItem>
  )
}

export default CustomRangeSlider
